import { removeMemberDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const removeMemberCallable = getCallable(removeMemberDefinition);
